import { Box, HStack, Text, VStack } from '@chakra-ui/react';

import { useState } from 'react';
import { MdOutlineQrCode2 } from 'react-icons/md';
import { RxExternalLink } from 'react-icons/rx';
import { useI18nLn } from '~/hooks/store';
import { RedeemTicket } from '~/types/resources/redeemTicket';
import { QRCodeModal } from './QRCodeModal';

type Props = {
  gachaID: string;
  redeemTickets: RedeemTicket[] | undefined;
};

export const OpenPickupQRCodeModalButton: React.FC<Props> = (props: Props) => {
  const { t } = useI18nLn();
  const redeem =
    props.redeemTickets?.find(
      (redeemTickets) => redeemTickets.gacha_id === props.gachaID
    ) ?? undefined;
  const [showModal, setShowModal] = useState(false);
  return (
    <Box
      w="full"
      rounded="md"
      borderWidth="1px"
      borderColor="border"
      cursor="pointer"
      bgColor="rgba(136, 89, 221, 0.1)"
      _hover={{
        borderColor: 'primary',
      }}
      onClick={() => setShowModal(true)}
    >
      <HStack w="full" h="full" px={2} py={1} justifyContent="space-between">
        <MdOutlineQrCode2 size={40} color="#9D57C7" />
        <VStack w="full" alignItems="flex-start" gap={1}>
          <Text color="primary" fontSize="md" fontWeight="bold">
            {t('pages.local_pickup.enter_prize_pickup')}
          </Text>
          <Text color="primary" fontSize="sm">
            {t('pages.local_pickup.display_qr_code')}
          </Text>
        </VStack>
        <RxExternalLink size={40} color="#9D57C7" />
      </HStack>
      <QRCodeModal
        redeem={redeem}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
    </Box>
  );
};
